import * as _ from 'underscore';
import { IPublishedConnectionInfo } from '../models/IPublishedConnectionInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { IPublishedConnection, IPublishedConnectionDetail } from '../ServerApi/types/IPublishedConnection';
import { IUsageInfo } from '../ServerApi/types/IUsageInfo';
import { MapperHelper } from './MapperHelper';
import { ProjectMapper } from './ProjectMapper';
import { UserMapper } from './UserMapper';

export module PublishedConnectionMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IPublishedConnection[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    favoritePublishedConnections: _.Dictionary<any> = {}
  ): IPublishedConnectionInfo[] {
    return serverApiMetrics.map((m: IPublishedConnection) => {
      return mapOne(m, users[m.ownerId], projects[m.projectId], !!favoritePublishedConnections[m.id]);
    });
  }

  export function mapOne(
    publishedConnection: IPublishedConnection,
    owner?: IUserInfo,
    project?: INamedItemInfo,
    favorite?: boolean
  ): IPublishedConnectionInfo {
    return {
      createdAt: M.toDate(publishedConnection.createdAt),
      updatedAt: M.toDate(publishedConnection.updatedAt),
      suspended: publishedConnection.suspended,
      description: publishedConnection.description,
      id: publishedConnection.id,
      name: publishedConnection.name,
      owner: UserMapper.mapOne(owner),
      favorite: favorite,
      contentType: 'publishedConnection',
      tags: M.sortTags(publishedConnection.tags),
      project: project,
      usageInfo: <IUsageInfo>{},
      usageInfoMaxValues: <IUsageInfo>{},
    };
  }

  export function mapDetail(p: IPublishedConnectionDetail): IPublishedConnectionInfo {
    return {
      createdAt: M.toDate(p.createdAt),
      updatedAt: M.toDate(p.updatedAt),
      description: p.description,
      id: p.id,
      name: p.name,
      owner: UserMapper.mapOne(p.owner),
      favorite: p.favorite,
      contentType: 'publishedConnection',
      tags: M.sortTags(p.tags),
      project: ProjectMapper.mapName(p.project),
      usageInfo: <IUsageInfo>{},
      usageInfoMaxValues: <IUsageInfo>{},
    };
  }
  export function mapFromCRASS(p: any): IPublishedConnectionInfo {
    return {
      createdAt: M.toDate(p.createdTime),
      updatedAt: M.toDate(p.modifiedTime),
      suspended: p.suspendState,
      description: p.description,
      id: p.id + '',
      name: p.title,
      favorite: false,
      contentType: 'publishedConnection',
      tags: M.sortTags(p.tags),
      project: null,
      owner: {
        id: p.ownerId + '',
        displayName: p.ownerName || '',
        username: p.ownerName || '',
        domainName: p.ownerDomain,
        isHiddenInternalUser: false
      },
      usageInfo: <IUsageInfo>{},
      usageInfoMaxValues: <IUsageInfo>{},
    };
  }
}
